export default "__VITE_ASSET__e2d06d1b__"